import script from "./ShowServices.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShowServices.vue?vue&type=script&setup=true&lang=ts"

import "./ShowServices.vue?vue&type=style&index=0&id=4c220788&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c220788"]])

export default __exports__